<p>inventorymanagedetail works!</p>
